export default {
    lang: {
        name: 'Name'
    }
}